import React, { useEffect } from 'react'

import DropDown from '../../../../../components/Input/DropDown'

import generateWeeklyDate from '../../../../../helpers/generateWeeklyDate'

const AvailabilityCalendarTitle = ({
  formattedPassedCategories,
  date,
  category,
  onCategoryChange,
}) => {
  useEffect(() => {
    if (!category && formattedPassedCategories?.length) {
      onCategoryChange(formattedPassedCategories[0]?.value)
    }
  }, [formattedPassedCategories])

  return (
    <div className="w-full flex justify-between items-end my-[24px]">
      <div className="flex flex-col items-start w-[200px]">
        <span className="mb-[6px] text-sm font-medium text-primary-100">Category</span>

        <DropDown
          placeholder="Select Category"
          menuItems={formattedPassedCategories}
          value={category}
          setValue={onCategoryChange}
        />
      </div>

      <div className="flex items-center">
        <b className="text-[24px] text-bold inline-block">{generateWeeklyDate(date)}</b>
      </div>
    </div>
  )
}

export default AvailabilityCalendarTitle
